module.exports = "/_next/static/images/8dcf274530b71ce1128d6b8d399322f6-two-people-looking-md@1x.jpg.webp";